import JSZip from "jszip";

// Protection prevents accidental changes to the import layout, not access to data.
export async function protectWorkerImportTemplate(
  workbook,
  dataSheet,
  columnCount,
) {
  for (let column = 1; column <= columnCount; column += 1) {
    dataSheet.getColumn(column).protection = { locked: false };
    dataSheet.getCell(1, column).protection = { locked: true };
  }
  for (const sheet of workbook.worksheets) {
    await sheet.protect("MHIS", {
      spinCount: 10000,
      selectLockedCells: sheet !== dataSheet,
      selectUnlockedCells: true,
      formatCells: false,
      // Allow resizing columns while headers and the import structure stay locked.
      formatColumns: true,
      formatRows: false,
      insertColumns: false,
      insertRows: false,
      deleteColumns: false,
      deleteRows: false,
      sort: false,
    });
  }
}

export async function writeProtectedWorkerImportTemplate(
  workbook,
  dataSheet,
  columnCount,
) {
  await protectWorkerImportTemplate(workbook, dataSheet, columnCount);
  const zip = await JSZip.loadAsync(await workbook.xlsx.writeBuffer());
  const file = zip.file("xl/workbook.xml");
  const xml = await file.async("string");
  // ExcelJS supports sheet protection but does not serialize workbook protection.
  // Legacy Excel password verifier for the same accidental-edit password, MHIS.
  const password = "MHIS";
  let hash = 0;
  for (let index = 0; index < password.length; index += 1) {
    const code = password.charCodeAt(index) << (index + 1);
    hash ^= (code & 0x7fff) | (code >> 15);
  }
  hash ^= password.length ^ 0xce4b;
  const protection = `<workbookProtection workbookPassword="${hash.toString(16).toUpperCase()}" lockStructure="1"/>`;
  const cleaned = xml.replace(/<workbookProtection\b[^>]*\/>/g, "");
  zip.file(
    "xl/workbook.xml",
    cleaned.replace(/<(bookViews|sheets)\b/, `${protection}<$1`),
  );
  return zip.generateAsync({ type: "uint8array", compression: "DEFLATE" });
}
